module.exports = __webpack_public_path__ + "img/tc.729aa51.svg";